module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container fuwuzhichi_sun1"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sun_left",
    attrs: {
      "id": "toggleDivzzy"
    }
  }, _vm._l((_vm.tablelist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "nei01"
    }, [_c('div', {
      staticClass: "neititle"
    }, [_vm._v(_vm._s(item.name) + "\n              "), _c('img', {
      attrs: {
        "width": "16px",
        "src": require("../../static/assets/images/xiala1.png")
      }
    })]), _vm._v(" "), _c('ul', _vm._l((item.son), function(itema, indexa) {
      return _c('li', {
        key: indexa,
        on: {
          "click": function($event) {
            return _vm.fuwuinfoanb(itema.scode)
          }
        }
      }, [_vm._v(_vm._s(itema.name))])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sun_left diannaolist"
  }, _vm._l((_vm.tablelist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "nei01"
    }, [_c('div', {
      staticClass: "neititle"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('ul', _vm._l((item.son), function(itema, indexa) {
      return _c('li', {
        key: indexa,
        on: {
          "click": function($event) {
            return _vm.fuwuinfoan(itema.scode)
          }
        }
      }, [_vm._v(_vm._s(itema.name))])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sun_right",
    attrs: {
      "id": "younei"
    }
  }, [_c('div', {
    staticClass: "nei01"
  }, [_c('div', {
    staticClass: "neititle"
  }, [_vm._v("当前栏目：" + _vm._s(_vm.fuwuname))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "table",
      "border-radius": "15px",
      "border": "2px solid #cccccc",
      "background": "#ffffff",
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin-left": "5%",
      "padding-top": "20px",
      "padding-bottom": "20px",
      "line-height": "40px",
      "float": "left"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.fuwuinfo.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "90%",
      "margin-left": "5%",
      "padding-top": "20px",
      "padding-bottom": "20px",
      "line-height": "40px",
      "float": "left",
      "color": "rgb(156 156 156)"
    }
  }, [_c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "16px"
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    staticStyle: {
      "color": "#44bcb9"
    }
  }), _vm._v("\n                " + _vm._s(_vm.fuwuinfo.visits) + " ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0px 10px",
      "font-size": "16px"
    }
  }, [_vm._v(" " + _vm._s(_vm.fuwuinfo.date) + " ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding fuwuzhichi_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated news_sun_ziti1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("服务与支持")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated news_sun_ziti2",
    staticStyle: {
      "color": "#e40230",
      "font-weight": "500",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_vm._v("\n          SERVICE AND SUPPORT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle_phone",
    staticStyle: {
      "display": "none"
    }
  }, [_c('button', {
    staticStyle: {
      "background": "none",
      "border": "none",
      "padding": "4px 6px",
      "font-size": "16px",
      "color": "#000",
      "width": "40%",
      "font-weight": "600",
      "/*     height": "70px",
      "*/\n    margin-right": "30px",
      "float": "left",
      "right": "14px",
      "height": "40px",
      "/*     z-index": "100",
      "*/\n/*     border-radius": "57px"
    },
    attrs: {
      "id": "toggleButton"
    }
  }, [_vm._v("点击选择栏目")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-472cd226"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Fuwu.vue
// module id = 105
// module chunks = 0